import type { IconProps } from './IconProps';
export function ArchiveIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="3" width="18" height="5" rx="1" />
      <path d="M5 8v12h14V8M10 12h4" />
    </svg>
  );
}
